module.exports = __webpack_public_path__ + "img/loginImage.7c34dffe.jpg";